module.exports = __webpack_public_path__ + "static/media/piper-rocket-background-tablet.93ae62b9.svg";